var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "v-btn",
        {
          staticClass: "mx-2",
          attrs: { id: "upload-btn", disabled: _vm.showModal },
          on: { click: _vm.show_modal },
        },
        [
          _c("span", { staticClass: "d-none d-md-inline pr-2" }, [
            _vm._v(" Load "),
          ]),
          _c("v-icon", [_vm._v(" mdi-cloud-upload ")]),
        ],
        1
      ),
      _c("UploadNexus", {
        attrs: { visible: _vm.showModal },
        on: { "close-modal": _vm.close_modal, "got-files": _vm.close_modal },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }